// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loading-content[data-v-95976d3a]{position:fixed;z-index:999999;background-color:hsla(0,0%,100%,.692)}.loading-spinner[data-v-95976d3a]{margin-top:40vh}", ""]);
// Exports
module.exports = exports;
